<template>
    <AppLayout>
        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-4">
                <div class="bg-white p-5 shadow-lg rounded-sm border border-gray-200">
                    <div class="flex items-center justify-between mb-3">
                        <div class="text-lg text-sky font-bold">Boti Cargo Shipping</div>
                    </div>
                    <ul class="mb-4">
                        <info-general-setting-detail :general-settings="generalSettings" :currency="currency" v-if="generalSettings" />
                        <info-contact-setting-detail :contact-settings="contactSettings" v-if="contactSettings" />
                    </ul>
                    <div class="border-l-4 bg-sky-100 border-sky-700 rounded-b text-sky-700 p-1 shadow-md">
                        <div class="flex items-center">
                            <i class="fad fa-engine-warning text-4xl text-sky-700 mr-3"></i>
                            <div>
                                <p class="font-bold text-sky-700 text-sm">Informations</p>
                                <div class="block text-sm">
                                    <label class="flex items-center">
                                        <span class="text-xs font-semibold">
                                            Cette partie est reservée aux paramètres d'utilisation de la plateforme Boti Cargo Shipping.
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-span-8">
                <div class="mb-1 pb-1">
                    <ul class="text-sm font-medium flex flex-nowrap overflow-x-scroll no-scrollbar space-x-2">
                        <li>
                            <Link :href="route('settings.general')"
                                class="whitespace-nowrap flex items-center p-2 mr-6 last:mr-0 first:pl-2 sm:first:pl-4 lg:first:pl-6 last:pr-2 sm:last:pr-4 lg:last:pr-6 rounded-md"
                                :class="route().current('settings.general') ? 'bg-sky hover:bg-sky-400 text-white font-bold' : 'bg-gray-100 text-gray-500 hover:bg-sky-400 hover:text-white'"
                            >
                                <InformationCircleIcon class="w-5 h-5 shrink-0 fill-current mr-2" />
                                <span>Générales</span>
                            </Link>
                        </li>
                        <li>
                            <Link :href="route('settings.contact')" class="whitespace-nowrap flex items-center p-2 mr-6 last:mr-0 first:pl-2 sm:first:pl-4 lg:first:pl-6 last:pr-2 sm:last:pr-4 lg:last:pr-6 rounded-md"
                                :class="route().current('settings.contact') ? 'bg-sky hover:bg-sky-400 text-white font-bold' : 'bg-gray-100 text-gray-500 hover:bg-sky-400 hover:text-white'"
                            >
                                <PhoneIcon class="w-5 h-5 shrink-0 fill-current mr-2" />
                                <span>Contacts</span>
                            </Link>
                        </li>
                    </ul>
                </div>

                <slot />
            </div>
        </div>
    </AppLayout>
</template>

<script>
    import { Link } from '@inertiajs/inertia-vue3';
    import AppLayout from '@/Layouts/AppLayout.vue'
    import { InformationCircleIcon, PhoneIcon } from '@heroicons/vue/solid'
    import InfoGeneralSettingDetail from '@/Components/InfoGeneralSettingDetail'
    import InfoContactSettingDetail from '@/Components/InfoContactSettingDetail'

    export default {
        props:  {
            currency: Object,
            generalSettings: Object,
            contactSettings: Object
        },

        components: {
            Link,
            AppLayout,
            PhoneIcon,
            InformationCircleIcon,
            InfoGeneralSettingDetail,
            InfoContactSettingDetail
        },
    }
</script>
